<template>
  <v-card tile>
    <v-toolbar card dark color="primary">
      <v-btn icon @click.native='close' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Edit Attendee</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="save">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <h3>Actions for this attendee:</h3>
      <v-layout class="py-4" row wrap>
        <v-flex mx-4>
          <v-btn flat color="success" dark @click="chooseEmailTemplaiteForInvitation">
            <v-icon class="mr-2" dark right>message</v-icon>
            Send featured attendee invitation
          </v-btn>
        </v-flex>

        <v-flex mx-4>
          <v-btn flat color="primary" dark @click="remindAttendee(formAttendee.id)">
            <v-icon class="mr-2" dark right>email</v-icon>
            Remind Attendee
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="putOnTop">
          <v-btn flat color="amber lighten-1" dark @click="changeStatusIsInTop(formAttendee.id)">
            <v-icon class="mr-2" dark right>star</v-icon>
            Remove from top of list
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-else>
          <v-btn color="amber lighten-1" flat dark @click="changeStatusIsInTop(formAttendee.id)">
            <v-icon class="mr-2" dark right>star_border</v-icon>
            Put on top of list
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="formAttendee.registrationStatus === 'PendingApprove'">
          <v-btn color="green lighten-1" flat dark @click="approveAttendee(formAttendee.id)">
            <v-icon class="mr-2" dark right>offline_pin</v-icon>
           Approve
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="isPosibleSendRequestForPayment">
          <v-btn color="purple darken-2" flat dark @click="chooseEmailTemplaiteForSendRequest()">
            <v-icon class="mr-2" dark right>near_me</v-icon>
           Send Request for peyment
          </v-btn>
        </v-flex>

        <v-flex mx-4>
          <v-btn color="purple darken-2" flat dark @click="chooseEmailTemplaiteForSendPhotoRequest()">
            <v-icon class="mr-2" dark right>face</v-icon>
           Send Request for photo
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="!isRejectedStatus">
          <v-btn color="red" flat dark @click="setStatusReject(formAttendee.id)">
            <v-icon class="mr-2" dark right>pan_tool</v-icon>
           Reject user
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="formAttendee.isBlocked">
          <v-btn color="deep-purple accent-2" flat dark @click="showConfirmationUnblock()">
            <v-icon class="mr-2" dark right>lock_open</v-icon>
           Unblock user
          </v-btn>
        </v-flex>
      </v-layout>
      <v-form>
        <v-layout row wrap justify-space-around>
          <v-flex xs6>

            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Personal Information</h3>
                  <v-layout row wrap justify-space-between align-center>
                    <v-flex md6>
                      <v-radio-group
                        row
                        label="Gender"
                        v-model="formAttendee.gender"
                      >
                        <v-radio label="Mr." value="Mr."></v-radio>
                        <v-radio label="Ms." value="Ms."></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex md2>
                      <strong>VIP type:</strong> {{formAttendee.isVip ? 'VIP attendee' : 'NO VIP'}}
                    </v-flex>
                    <v-flex md2>
                      <strong>Super User:</strong> {{formAttendee.isSuperUser ? 'YES' : 'NO'}}
                    </v-flex>
                    <v-flex md2>
                      <strong>Virtual Vision:</strong> {{formAttendee.isVirtualVision ? 'YES' : 'NO'}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <content-field
                        v-model="formAttendee.firstName"
                        :error="$v.formAttendee.firstName"
                        label="First Name"/>
                    </v-flex>
                    <v-flex xs5>
                       <content-field
                        v-model="formAttendee.lastName"
                        :error="$v.formAttendee.lastName"
                        label="Last Name"/>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>

                    <v-flex xs5>
                      <content-field
                      label="Email"
                      :error="$v.formAttendee.email"
                      v-model="formAttendee.email"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                      label="Birth Year"
                      :error="$v.formAttendee.birthYear"
                      v-model="formAttendee.birthYear"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                      label="VAT ID"
                      :error="$v.formAttendee.vatId"
                      v-model="formAttendee.vatId"/>
                    </v-flex>
                  </v-layout>

                </v-flex>

                <v-flex class="pt-4 text-xs-center">
                  <v-card-media
                    v-if="avatar"
                    :src="avatar"
                    height="200px"
                    class="image-style"
                  />
                  <a-upload-section
                    class="upload-button"
                    :preventGallery="true"
                    :btnAppearance="btnAppearance"
                    @lastUploadedPhotos="handlePhoto"
                  />
                  <v-btn
                    :disabled="!formAttendee.imageUrl"
                     color="success"
                     @click="formAttendee.imageUrl = ''">
                    Remove Image
                  </v-btn>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Contact Information</h3>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <v-select
                        :items="countries"
                        @change="setCountryCode"
                        v-model="formAttendee.country"
                        :error="$v.formAttendee.country.$error"
                        label="Country"
                        item-value="name"
                        item-text="name"
                      />
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        label="Phone Number"
                        v-model="formAttendee.phoneNumber"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrpa justify-space-between>
                    <v-flex xs5>
                      <content-field
                        label="Address"
                        :error="$v.formAttendee.address"
                        v-model="formAttendee.address"/>
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        label="City"
                        :error="$v.formAttendee.city"
                        v-model="formAttendee.city"/>
                    </v-flex>
                  </v-layout>
                  <content-field
                    v-if="attendee.category && attendee.category.showAccountManagerEmail"
                    label="Account Manager Email"
                    v-model="formAttendee.accountManagerEmail"/>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Company Information</h3>
                  <v-layout wrap row justify-space-between>
                    <v-flex xs5>
                       <content-field
                        v-model="formAttendee.company"
                        :error="$v.formAttendee.company"
                        label="Company"/>
                    </v-flex>
                    <v-flex xs5>
                       <content-field
                        v-model="formAttendee.jobTitle"
                        :error="$v.formAttendee.jobTitle"
                        label="Job Title"/>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap row justify-space-between>
                    <v-flex xs5>
                      <content-field
                        v-if='formAttendee.category'
                        v-model="formAttendee.category.badgeDisplayName"
                        readonly
                        label="Badge category"/>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap row justify-space-between>
                    <v-flex xs5>
                      <content-field
                        v-model="formAttendee.corporateAddress"
                        :error="$v.formAttendee.corporateAddress"
                        label="Corporate Address"/>
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        v-model="formAttendee.corporateWebSite"
                        :error="$v.formAttendee.corporateWebSite"
                        label="Corporate WebSite"/>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap row justify-space-between>
                    <v-flex xs5>
                      <v-select
                        label="Category"
                        :items="filteredCategories"
                        v-model="formAttendee.category.id"
                        item-text="name"
                        item-value="id"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- <pre>{{ filteredCategories }}</pre> -->

                  <v-layout wrap row justify-space-between
                    v-if="currentSubCategories">
                    <v-flex xs5>
                      <v-select
                        label="Sub category"
                        :items="currentSubCategories"
                        v-model="formAttendee.subCategory"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout wrap row justify-space-between>
                    <v-flex xs5>
                      <v-select
                        label="Category type"
                        :items="categoriesTypes"
                        v-model="formAttendee.category.type"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3 v-if="!attendeeHasPackage">
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Package isn't chosen yet. Assign package manually: </h3>
                  <v-layout column>
                    <v-flex xs12>
                      <v-select
                        :items="packagesList"
                        v-model="assignedPackageData.packageId"
                        item-value="id"
                        item-text="name"
                        label="Assign package">
                      </v-select>
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        v-model="assignedPackageData.ticketsCount"
                        label="Assign tickets count"/>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="activePromoCodes"
                        v-model="assignedPackageData.promoCode"
                        item-value="code"
                        item-text="name"
                        label="Assign promo code">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3 v-if="attendeeHasPackage">
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Package Information</h3>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <content-field
                        readonly
                        v-model="getPackageFromFormAttendee.name"
                        label="Name"/>
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        readonly
                        :value="getPackageFromFormAttendee.price || 'unknown'"
                        label="Price"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <content-field
                        readonly
                        v-model="getPackageFromFormAttendee.status"
                        label="Status"/>
                    </v-flex>
                    <v-flex xs5>
                       <content-field
                        readonly
                        v-model="getPackageFromFormAttendee.type"
                        label="Type"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <content-field
                        readonly
                        v-model="getPackageFromFormAttendee.creationDate"
                        label="Creation Date"/>
                    </v-flex>
                    <v-flex xs5>
                      <content-field
                        v-model="packageInfo.messagesLimit"
                        label="Message Limit"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs5>
                      <content-field
                        readonly
                        v-model="getPackageFromFormAttendee.title"
                        label="Title"/>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pa-3>
                  <h4>Choose different package:</h4>
                  <v-switch
                    label="Change package"
                    v-model="isPackageChanged"
                  />
                  <v-select
                    v-if="isPackageChanged"
                    :items="packagesList"
                    v-model="newChosenPackageId"
                    item-value="id"
                    item-text="name"
                    label="Packages list">
                  </v-select>
                </v-flex>
                <v-flex xs12 pa-3
                  v-if="formAttendee.affiliateImageUrl && formAttendee.affiliateImageUrl.length"
                >
                  <h4>Affiliate:</h4>
                  <a
                    target="_blank"
                    class="wordBreak"
                    :href="formAttendee.affiliateImageUrl"
                  >
                    Download Affiliate Image
                  </a>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3 v-if="arePredefinedActivitiesVisible">
              <h3>Predefined activities </h3>
              <v-layout row wrap>
                <v-flex xs12 class="my-4">
                  <div v-for="(value) in predefinedActivity" :key="`predefined-activity-${value.id}`">
                    <v-checkbox
                      v-model="selectedActivities"
                      :label="value.title"
                      :value="value.id"
                    />
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-flex>
          <v-flex xs6>

            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Additional Information</h3>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs3>
                      <content-field
                        solo
                        v-model="formAttendee.registrationStatus"
                        readonly
                        label="Status"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        v-model="formAttendee.uniqueId"
                        solo
                        readonly
                        label="Unique id"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        :value="formAttendee.registrationIp || 'None'"
                        solo
                        readonly
                        label="IP Address"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs3>
                      <content-field
                        :value="formAttendee.paymentType || 'None'"
                        solo
                        readonly
                        label="Payment Type"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        :value="formAttendee.paymentProvider || 'None'"
                        solo
                        readonly
                        label="Payment provider"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        :value="returnPaymentStatus"
                        readonly
                        label="Payment status"/>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex xs3>
                      <content-field
                        :value="isSentConfirmationEmail"
                        readonly
                        label="Confirmation email sent"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        type="number"
                        readonly
                        v-model="formAttendee.ticketsCount"
                        label="Tickets Count"/>
                    </v-flex>
                    <v-flex xs3>
                      <content-field
                        v-if="formAttendee"
                        type="number"
                        readonly
                        v-model="formAttendee.messagesUsed"
                        label="Messages used"/>
                    </v-flex>
                  </v-layout>
                  <v-layout row justify-space-around>
                    <content-field
                      v-if="formAttendee.selectedPromoCode"
                      :value="formAttendee.selectedPromoCode"
                      readonly
                      label="Assigned Promo Code"/>
                    <content-field
                      :value="getInfoByPromocode"
                      readonly
                      label="Promo Code"/>
                    <content-field
                      :value="getInfoByDiscount"
                      readonly
                      label="Dicount"/>
                  </v-layout>
                   <v-layout row justify-space-around>
                    <content-field
                      :value="formAttendee.isStepOneVoted ? 'YES' : 'NO'"
                      readonly
                      label="Round 1 Vote"/>
                    <content-field
                      :value="formAttendee.isStepTwoVoted ? 'YES' : 'NO'"
                      readonly
                      label="Round 2 Vote"/>
                     <v-flex xs4>
                       <content-field
                         solo
                         v-model="attendeeCreationDate"
                         readonly
                         label="Creation Date"/>
                     </v-flex>
                  </v-layout>

                  <content-field
                    label="Comments"
                    v-model="formAttendee.comments"/>
                  <content-field
                    label="Booth Number"
                    v-model="formAttendee.boothNumber"/>
                  <v-select
                    :items="attendeTypesList"
                    v-model="formAttendee.attendeeType"
                    item-value="id"
                    item-text="title"
                    label="Attendee Types">
                  </v-select>
                  <content-field
                    v-model="formAttendee.cid"
                    label="CID"/>

                  <h3 v-if="formAttendee.featureFormToken" class="text-xs-center py-2 px-2 my-3">
                    <v-btn fab dark small color="primary"
                      v-clipboard:copy="`${eventLink}registration/featured-attendee-registration?token=${formAttendee.featureFormToken.token}`"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <v-icon dark>content_copy</v-icon>
                    </v-btn>
                    Link to featured attendee registration page:
                    <a
                      target="_blank"
                      class="wordBreak"
                      :href="`${eventLink}registration/featured-attendee-registration?token=${formAttendee.featureFormToken.token}`"
                    >
                      {{`${eventLink}registration/featured-attendee-registration?token=${formAttendee.featureFormToken.token}`}}
                    </a>
                  </h3>
                  <h3 v-if="formAttendee.vipInvitation" class="text-xs-center py-2 px-2 my-3">
                    <v-btn fab dark small color="primary"
                      v-clipboard:copy="`${eventLink}registration/${formAttendee.vipInvitation.slug}/${formAttendee.vipInvitation.code}`"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <v-icon dark>content_copy</v-icon>
                    </v-btn>
                    Link to vip attendee registration page:
                    <a
                      target="_blank"
                      class="wordBreak"
                      :href="`${eventLink}registration/${formAttendee.vipInvitation.slug}/${formAttendee.vipInvitation.code}`"
                    >
                      {{`${eventLink}registration/${formAttendee.vipInvitation.slug}/${formAttendee.vipInvitation.code}`}}
                    </a>
                  </h3>
                  <h3 v-if="formAttendee.confirmationToken" class="text-xs-center py-2 px-2 my-3">
                    <v-btn fab dark small color="primary"
                      v-clipboard:copy="`${eventLink}registration/completed?token=${formAttendee.confirmationToken}`"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <v-icon dark>content_copy</v-icon>
                    </v-btn>
                    Link to confirm registration:
                    <a
                      target="_blank"
                      class="wordBreak"
                      :href="`${eventLink}registration/completed?token=${formAttendee.confirmationToken}`"
                    >
                      {{`${eventLink}registration/completed?token=${formAttendee.confirmationToken}`}}
                    </a>
                  </h3>
                  <h3 v-if="formAttendee.voucherToken" class="text-xs-center py-2 px-2 my-3">
                    <v-btn fab dark small color="primary"
                      v-clipboard:copy="`${eventLink}voucher?token=${formAttendee.voucherToken}`"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <v-icon dark>content_copy</v-icon>
                    </v-btn>
                     Your Admission Link:
                    <a
                      target="_blank"
                      class="wordBreak"
                      :href="`${eventLink}voucher?token=${formAttendee.voucherToken}`"
                    >
                      {{`${eventLink}voucher?token=${formAttendee.voucherToken}`}}
                    </a>
                  </h3>
                </v-flex>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>


          <v-flex ma-3 v-if="attendeeRegistrationForm.id">
            <v-card ma-2 class="elevation-4">
              <v-flex pa-3 md6>
                <h3>Fields created by Admin</h3>
                <form-interpretator
                  v-if="attendeeRegistrationForm && formAttendee"
                  :formType="attendeeRegistrationForm.type"
                  :formId="attendeeRegistrationForm.id"
                  :formGroup="attendeeRegistrationForm.group"
                  :formFields="attendeeRegistrationForm.fields"
                  :formMetadata="attendeeRegistrationForm.metadata"
                  :editableItem="formAttendee"
                  @submit="onSubmitForm"
                  ref="formInterpretator"
                  :showRemoveImageBtn="false"
                />
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex ma-3 v-if="!isEmpty(formAttendee.featureFormMetadataObject)">
            <v-card ma-2 class="elevation-4">
              <v-flex pa-3 md6>
                <h3>Featured attendee form</h3>
                <form-interpretator
                  v-if="featuredAttendeeForm && featuredAttendeeData.metadata"
                  :formType="featuredAttendeeForm.type"
                  :formId="featuredAttendeeForm.id"
                  :formGroup="featuredAttendeeForm.group"
                  :formFields="featuredAttendeeForm.fields"
                  :formMetadata="featuredAttendeeForm.metadata"
                  :editableItem="featuredAttendeeData"
                  @submit="onSubmitFeaturedAttendeeForm"
                  ref="featuredAttendeeformInterpretator"
                  :showRemoveImageBtn="false"
                />
              </v-flex>
            </v-card>
          </v-flex>


        <v-container mt-5 fluid row>
          <h3>Killer Feature Tags</h3>
          <v-layout row wrap>
            <v-flex
              v-for="item in tagsByType"
              :key="`killer-feature-${item.id}`"
              ma-3
              xs3
            >
              <v-card class="elevation-5">
                <v-flex pa-2>
                  <v-checkbox
                    :value="item.id"
                    v-model="checkboxes"
                    :label="item.displayName"/>
                  <content-field
                    :v-if="isSellCategory"
                    label="Comment"
                    v-model="comments[item.id]"/>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>



          <v-layout mt-5 row>


            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>Newsletter Subscription</h3>
                  <v-flex mt-4>
                    <v-checkbox
                      v-model="formAttendee.subscribeNewsletter"
                      label="Subscribe to Company Newsletter"/>
                  </v-flex>
                  <!-- <v-flex>
                    <v-checkbox
                      v-model="formAttendee.subscribeProductsUpdates"
                      label="Subscribe to product Updates"/>
                  </v-flex> -->
                  <v-flex>
                    <v-checkbox
                      v-model="formAttendee.subscribeToEventsInfo"
                      label="Subscribe to Events info"/>
                  </v-flex>
                  <v-flex>
                    <v-checkbox
                      v-model="formAttendee.subscribeToDailyNews"
                      label="Subscribe to Daily News"/>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex ma-3>
              <v-card ma-2 class="elevation-4">
                <v-flex pa-3>
                  <h3>User Settings</h3>
                  <v-flex mt-4>
                    <v-checkbox
                      v-model="formAttendee.isRemovedFromKillerFeatureSearch"
                      label="Hide from search by Killer Feature Tag"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex>
                    <v-checkbox
                      v-model="putOnTop"
                      @click="changeStatusIsInTop(formAttendee.id)"
                      label="Show Attendee in Top of the Attendees List"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex>
                    <v-checkbox
                      v-model="isRejectedStatus"
                      @click="setStatusReject(formAttendee.id)"
                      label="Attendee is blocked (This User will not able to login)"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-flex>

          </v-layout>

      </v-form>

    </v-card-text>

    <!-- DIALOGS -->

    <v-dialog persistent v-model="isConfirmationUnblock" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are You sure You want to unblock the attendee? </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="unblockAttendee()">Unblock</v-btn>
          <v-btn color="info" flat @click="hideConfirmationUnblock">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isChooseEmailTemplateBlock" max-width="500px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Choose email template for send request for payment</span>
          <v-flex class="py-2">
            <v-select
              :items="requestForPaymentTemplatesList"
              v-model="emailTemplateKey"
              label="Email Template"
              item-value="templateKey"
              item-text="templateKey"
            />
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="cancelActionOfChoose">Cancel</v-btn>
          <v-btn color="success" flat @click="sendRequestForPeyment()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isChoosePhotoEmailTemplateBlock" max-width="500px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Do you want to submit request for photo?</span>
          <span class="headline mb-0 text-md-center">Choose email template for send request for photo</span>
          <v-flex class="py-2">
            <v-select
              :items="requestForPhotoTemplatesList"
              v-model="emailTemplateKey"
              label="Email Template"
              item-value="templateKey"
              item-text="templateKey"
            />
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="cancelActionOfChoose">Cancel</v-btn>
          <v-btn color="success" flat @click="isendRequestForPhoto()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isSelectETemplateForFAInvitation" max-width="500px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Choose email template for send featured attendee invitation</span>
          <v-flex class="py-2">
            <v-select
              :items="featuredAttendeeInvitationTemplatesList"
              v-model="emailTemplateKey"
              label="Email Template"
              item-value="templateKey"
              item-text="templateKey"
            />
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="cancelActionOfChoose">Cancel</v-btn>
          <v-btn color="success" flat @click="sendFeaturedAttendeeInvitation()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import ContentField from '@/components/shared/ContentField/index.vue'
import {clone, prop, map, omit, pathOr, path, compose, isEmpty, isNil, pick, head, equals, sort} from 'ramda'
import { mapState, mapActions, mapGetters } from 'vuex'
import FormInterpretator from '@/components/shared/EvFormInterpretator'
import AUploadSection from '@/components/shared/AUploadSection'
import moment from 'moment'
import countries from '@/utils/countryCodes'
import { required, email } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'

const diffStrings = (a, b) => a.localeCompare(b)

export default {
  name: 'FormEditAttendee',
  components: {
    AUploadSection,
    ContentField,
    FormInterpretator
  },
  mixins: [mixins.emailTemplates],
  props: {
    attendee: {
      type: Object,
      default: () => ({})
    },
    attendeTypesList: {
      type: Array,
      default: () => ([])
    },
    attendeeFullInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      categoriesTypes: ['Buy', 'Sell'],
      allCategories: [],
      filteredCategories: [],
      countries,
      putOnTop: false,
      assignedPackageData: {
        packageId: null,
        ticketsCount: null,
        promoCode: null
      },
      iHateVue: true,
      isPackageChanged: false,
      newChosenPackageId: '',
      formAttendee: null,
      attendeeRegistrationForm: {},
      featuredAttendeeForm: {},
      featuredAttendeeData: {},
      amountsymbolsVatId: null,
      comments: {},
      checkboxes: [],
      isConfirmationUnblock: false,
      isChooseEmailTemplateBlock: false,
      isChoosePhotoEmailTemplateBlock: false,
      isSelectETemplateForFAInvitation: false,
      emailTemplateKey: '',
      selectedActivities: [],
      btnAppearance: {
        text: 'Choose Image',
        color: 'success',
        raised: true,
        hideIcon: true
      }
    }
  },
  validations () {
    const validationObj = {
      formAttendee: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        country: { required },
        // address: { required },
        // city: { required },
        // jobTitle: { required }
        company: { required }
      }
    }
    // if (this.getVatIdValidationEnabled) {
    //   validationObj.formAttendee.vatId = {
    //     vatId: value => {
    //         const regExp = new RegExp(`^(?:[A-Z]{2})?\\d{${this.amountsymbolsVatId}}$`, 'gm')
    //         return regExp.test(value)
    //     }
    //   }
    // }
    return validationObj
  },
  watch: {
    'formAttendee.category.type' () {
      this.filterAllCategories()
    },
    categoriesList: {
      handler: function (newVal) {
        this.allCategories = clone(newVal)
        this.filterAllCategories()
      },
      deep: true,
      immediate: true
    },
    attendee: {
      handler(val) {
        this.formAttendee = clone(val)
        this.formAttendee.category = this.formAttendee.category || {}
        this.formAttendee.metadata = this.formAttendee.metadataObject
      },
      immediate: true
    },
    formAttendee: {
      handler (val) {
        if (!this.formAttendee.tags) return
        this.checkboxes = map(prop('id'), this.formAttendee.tags)
        this.comments = this.formAttendee.tags.reduce((acc, curr) => {
          acc[curr.id] = curr.comment
          return acc
        }, {})
      },
      immediate: true
    }
  },
  computed: {
    ...mapState ({
      activePromoCodes: state => {
        const promoCodes = state.promoCodes.promoCodes
        const currentTime = moment()
        return promoCodes.filter(code => {
          const isActive = moment(code.expirationDate).diff(currentTime) >= 0
          return isActive && code.status === 'Live'
        })
      }
    }),
    ...mapGetters ([
      'eventLink',
      'tagsByType',
      'getFormData',
      'getVatIdSettings',
      'getVatIdValidationEnabled',
      'packagesList',
      'predefinedActivity',
      'promoCodesList',
      'categoriesList'
    ]),
    avatar () {
      return this.iHateVue ? this.formAttendee.imageUrl : this.formAttendee.imageUrl
    },
    isRejectedStatus () {
      return path(['attendees', '0', 'registrationStatus'], this.attendeeFullInfo) === 'Rejected'
    },
    arePredefinedActivitiesVisible () {
      return !!(this.arePredefinedActivitiesExist && !this.isRegistrationStatusPendingPackageSelection)
    },
    isPredefinedActivitiesChanged () {
      return !equals(sort(diffStrings, this.selectedActivities), sort(diffStrings, this.attendeeActivitiesIds))
    },
    isRegistrationStatusPendingPackageSelection () {
      return this.formAttendee.registrationStatus === 'PendingPackageSelection'
    },
    arePredefinedActivitiesExist () {
      return this.predefinedActivity.length
    },
    isPackageEmpty () {
      return isNil(prop('package', this.formAttendee))
    },
    packageInfo () {
      const isEmptyPackage = isNil(prop('package', this.formAttendee))
      const packageField = isEmptyPackage ? 'invitationPackage' : 'package'
      return prop(packageField, this.formAttendee)
    },
    attendeeActivitiesIds () {
      const propOfPackageData = this.isPackageEmpty ? 'invitationPackage' : 'package'
      const activitiesList = path([propOfPackageData, 'activities'], this.formAttendee)
      const ActivitiesIds = activitiesList.map((activity)=> {return activity.id})
      return ActivitiesIds
    },
    isSellCategory () {
      return this.attendee.category.type === 'Sell'
    },
    isSentConfirmationEmail () {
      const isInConfirmStatus = this.formAttendee.registrationStatus === 'PendingConfirmation' || this.formAttendee.registrationStatus === 'Completed'
      return isInConfirmStatus ? 'YES' : 'NO'
    },

    attendeeHasPackage () {
      const invitationPackage = prop(['invitationPackage'], this.formAttendee)
      return pathOr(invitationPackage, ['package', 'id'], this.formAttendee)
    },
    getPackageFromFormAttendee () {
      const originalPackage = prop(['package'], this.formAttendee)
      const invitationPackage = prop(['invitationPackage'], this.formAttendee)
      const fallBackPackage = {name: 'Package not setting yet'}

      const attendeePackage = originalPackage || invitationPackage || fallBackPackage

      if (attendeePackage.creationDate) {
        attendeePackage.creationDate = moment(attendeePackage.creationDate).format('LLL')
      }
      return attendeePackage
    },
    attendeeCreationDate () {
      return moment(this.formAttendee.registrationDate).format('LLL')
    },
    isPosibleSendRequestForPayment () {
      const isPendingPayment = this.formAttendee.registrationStatus === 'PendingPayment'
      const isRequestPayment = this.formAttendee.registrationStatus === 'RequestForPayment'
      return (isPendingPayment || isRequestPayment) && !this.formAttendee.isVip
    },
    getInfoByDiscount () {
      return path(['vipInvitation', 'discountInCurrency'], this.formAttendee) || path(['vipInvitation', 'discountInPercent'], this.formAttendee) || 'None'
    },
    getInfoByPromocode () {
      return pathOr('None', ['promoCode', 'code'], this.formAttendee)
    },
    returnPaymentStatus() {
      if (path(['type'], this.getPackageFromFormAttendee) === 'Free') {
        return 'N/A'
      } else {
        if (!this.formAttendee.transactions.length) {
          return 'Not paid'
        } else {
          const lastTransactionInfo = this.formAttendee.transactions.length - 1
          switch (this.formAttendee.transactions[lastTransactionInfo].status) {
            case 'Approved': return 'Paid'
            case 'Created': return 'Panding'
            default: return 'Faild'
          }
        }
      }
    },
    currentSubCategories () {
      let category = this.filteredCategories.find(category => category.id === this.formAttendee.category.id)
      return category ? category.subCategories : null
    }
  },
  methods: {
    ...mapActions ([
      'getTagByType',
      'getInterpritationFormData',
      'editRegularAttendee',
      'editVipAttendee',
      'deleteAllAttendeeRecords',
      'setAttendeeApproveStatus',
      'sendFeaturedInvitation',
      'sendAttendeeReminders',
      'updateIsInTopStatus',
      'unblockBlockedAttendee',
      'sendRequestForPayment',
      'sendRequestForPhoto',
      'rejectAttendee',
      'getPackagesList',
      'changePackageOfAttendee',
      'changePackageOfVipAttendee',
      'getPredefinedActivity',
      'assignPackageToPendingPackageAttendee',
      'getPromoCodesList'
    ]),
    path,
    isEmpty,
    pick,
    onCopy () {
      this.showResultSuccessMessage('The Variable Name was added to clipboard.')
    },
    onError () {
      this.showResultErrorMessage()
    },
    // METHODS for attendee actions

    handlePhoto (photos) {
      try {
        this.formAttendee.imageUrl = photos[0].imagesUrls.originalImageUrl
        this.iHateVue = !this.iHateVue
      } catch (e) {
        console.log('Image not found', e)
      }
    },
    async approveAttendee (id) {
      try {
        await this.setAttendeeApproveStatus(id)
        this.$bus.$emit('reloadTable', 'editAttendee')
      } catch (err) {
        throw err
      }
    },
    async setStatusReject (id) {
      try {
        await this.rejectAttendee(id)
        this.$bus.$emit('reloadTable', 'editAttendee')
      } catch (err) {
        throw err
      }
    },
    async sendFeaturedAttendeeInvitation () {
      const payload = {
        'attendeeId': this.formAttendee.id,
        'emailTemplateKey': this.emailTemplateKey
      }
      try {
        await this.sendFeaturedInvitation(payload)
      } catch (err) {
        throw err
      }
      this.cancelActionOfChoose()
    },
    async remindAttendee (attendeeId) {
      try {
        await this.sendAttendeeReminders(attendeeId)
      } catch (err) {
        throw err
      }
    },
    async changeStatusIsInTop(id) {
      try {
        this.putOnTop = !this.putOnTop
        await this.updateIsInTopStatus({'ids' : [id], 'isInTop': this.putOnTop})
      } catch (err) {
        console.log('err', err)
      }
    },
    async unblockAttendee () {
      try {
        await this.unblockBlockedAttendee(this.formAttendee.id)
      } catch (err) {
        throw err
      }
      this.hideConfirmationUnblock()
    },
    async sendRequestForPeyment() {
      const payload = {
        id: this.formAttendee.id,
        emailTemplateKey: this.emailTemplateKey
      }
      try {
        await this.sendRequestForPayment(payload)
      } catch(err) {
        throw err
      }
      this.cancelActionOfChoose()
    },
    async isendRequestForPhoto() {
      const payload = {
        id: this.formAttendee.id,
        emailTemplateKey: this.emailTemplateKey || "Attendee Submit Image"
      }
      try {
        await this.sendRequestForPhoto(payload)
      } catch(err) {
        throw err
      }
      this.cancelActionOfChoose()
    },
    chooseEmailTemplaiteForSendRequest () {
      this.isChooseEmailTemplateBlock = true
    },
    chooseEmailTemplaiteForSendPhotoRequest () {
      this.isChoosePhotoEmailTemplateBlock = true
    },
    chooseEmailTemplaiteForInvitation () {
      this.isSelectETemplateForFAInvitation = true
    },
    cancelActionOfChoose() {
      this.isChoosePhotoEmailTemplateBlock = false
      this.isChooseEmailTemplateBlock = false
      this.isSelectETemplateForFAInvitation = false
      this.emailTemplateKey = ''
    },
    showConfirmationUnblock () {
      this.isConfirmationUnblock = true
    },
    hideConfirmationUnblock () {
      this.isConfirmationUnblock = false
    },

    // END METHODS for attendee actions

    setCountryCode (country) {
      const chosenCountry = countries.find(item => {
        return country === item.name
      })
      this.formAttendee.countryCode = chosenCountry.code
    },
    setTagsToForm () {
      const arr = this.checkboxes.reduce((acc, curr) => {
        acc.push({
          id: curr,
          comment: this.comments[curr]
        })
        return acc
      }, [])
      this.formAttendee.tags = [...arr]
    },
    close () {
      this.$emit('close')
      this.$v.$reset()
    },
    save () {
      this.$v.formAttendee.$touch()
      if (this.$v.formAttendee.$invalid) return false
      if (!this.isEmpty(this.formAttendee.featureFormMetadataObject)) {
        this.$refs.featuredAttendeeformInterpretator.submitForm()
      }
      this.$refs.formInterpretator.submitForm()
      this.$bus.$emit('reloadTable', 'editAttendee')
    },
    onSubmitFeaturedAttendeeForm (form) {
      if (!isNil(this.formAttendee.featureFormMetadataObject)) {
        this.formAttendee.featureFormMetadata = clone(form)
      }
    },
    async onSubmitForm (form) {
      try {
        this.setTagsToForm()
        this.formAttendee.metadata = clone(form)
        let payload = clone(this.formAttendee)
        payload.attendeeTypeId = path(['attendeeType', 'id'], this.formAttendee) || path(['attendeeType'], this.formAttendee)
        payload = omit(['category', 'metadataObject', 'package', 'registrationStatus', 'uniqueId', 'attendeeType', 'accountManagerEmail', 'featureFormMetadata'], payload)
        const propOfPackageData = this.isPackageEmpty ? 'invitationPackage' : 'package'
        if (this.attendeeHasPackage && !this.isRegistrationStatusPendingPackageSelection) {
          payload.messageLimit = path([propOfPackageData, 'messagesLimit'], this.formAttendee)
        }
        payload.categoryId = path(['category', 'id'], this.formAttendee)
        const submitHandler = payload.isVip ? this.editVipAttendee : this.editRegularAttendee
        await submitHandler(payload)
        const submitPackageHandler = payload.isVip ? this.changePackageOfVipAttendee : this.changePackageOfAttendee
        const attendeeIdKey = payload.isVip ? 'vipAttendeeId' : 'attendeeId'
        const attendeeId = path(['id'], this.formAttendee)
        if (!isNil(this.assignedPackageData.packageId)) {
          const payloadToAssignPackage = {
            'attendeeId': attendeeId,
            'packageId': this.assignedPackageData.packageId,
            'ticketsCount': this.assignedPackageData.ticketsCount,
            'promoCode': this.assignedPackageData.promoCode
          }
          this.assignPackageToPendingPackageAttendee(payloadToAssignPackage)
          return
        }
        // else if (this.isRegistrationStatusPendingPackageSelection && isNil(this.assignedPackageData.packageId)){
        //   console.log('this.isRegistrationStatusPendingPackageSelection && isNil(this.assignedPackageData.packageId)')
        //   return
        // }

        if (this.isPackageChanged) {
          let newPackage = this.packagesList.find((packageItem)=> packageItem.id === this.newChosenPackageId)
          newPackage = pick(['name', 'title', 'subTitle', 'messagesLimit', 'confirmationEmailTemplateName', 'failedPaymentEmailTemplateName', 'predefinedActivities', 'multiUserConfirmationEmailTemplateKey', 'multiUserFailedPaymentEmailTemplateKey'], newPackage)
          let predefinedActivities = this.isPredefinedActivitiesChanged ? [...this.selectedActivities] : path(['predefinedActivities'], newPackage)
          newPackage = {
            ...newPackage,
            [attendeeIdKey] : attendeeId,
            predefinedActivities,
            PackageId: this.newChosenPackageId
          }
          await submitPackageHandler(newPackage)
        }

        if (!this.isPackageChanged && this.attendeeHasPackage) {
          let payload = {[attendeeIdKey] : attendeeId, 'predefinedActivities': [...this.selectedActivities]}
          await submitPackageHandler(payload)
        }
      } catch (err) {
        throw err
      }
      this.close()
    },
    async receiveRequestedData () {
      if (this.attendee.category && this.attendee.category.type) await this.getTagByType(this.attendee.category.type)
      await this.getPackagesList()
      await this.getPredefinedActivity()
      await this.getPromoCodesList()
      if (this.formAttendee.featureFormMetadataObject) {
        this.featuredAttendeeForm = await this.getInterpritationFormData('attendee_feature_form')
        this.featuredAttendeeData.metadata = clone(this.formAttendee.featureFormMetadataObject)
      }
      this.attendeeRegistrationForm = await this.getInterpritationFormData('attendee_registration')
      this.amountsymbolsVatId = path(['validationDigitsCount'], this.getVatIdSettings)
      this.selectedActivities = clone(this.attendeeActivitiesIds)
    },
    filterAllCategories () {
      this.filteredCategories = this.allCategories.filter((category) => {
        return category.status === 'Enabled' && category.categoryType === 'None' && category.type === path(['category', 'type'], this.formAttendee)
      })
    }
  },
  mounted () {
    this.putOnTop = pathOr(false, ['attendees', '0', 'isInTop'], this.attendeeFullInfo)
  },
  created () {
    this.receiveRequestedData()
  }
}
</script>

<style>
  .wordBreak {
    word-break: break-all;
  }

  .image-style {
    margin: auto;
    width: 200px;
  }

  .upload-button {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AllAttendee/FormEditAttendee.vue